/*
  Variant switching without a page load.

  The edition radios already carry the variant id, so the form was always
  correct on submit. Everything AROUND them was not: the price stayed on
  whichever variant rendered first, the URL never changed, and — the one
  that actually costs money — the hidden selling_plan input kept the
  plan belonging to the first variant. Choose "Founding — annual" after
  the page had loaded on "Standard — monthly" and you would submit an
  annual variant against a monthly plan.

  Data comes from a JSON script tag rendered by product.liquid, with
  prices pre-formatted by Liquid's `money` filter so currency and
  separators match the rest of the store rather than being reinvented
  here.

  No framework, no fetch. Nothing here is required for a purchase: with
  the script absent the radios still submit the right variant id, which
  is why it was safe to leave broken and is now merely better.
*/
(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;

  const dataEl = document.getElementById('product-variant-data');
  if (!dataEl) return;

  let variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }

  const byId = new Map(variants.map((v) => [String(v.id), v]));

  const priceEl = root.querySelector('[data-price]');
  const planHidden = root.querySelector('input[name="selling_plan"][type="hidden"]');
  const recursEl = root.querySelector('[data-recurs]');
  const submit = root.querySelector('[data-submit]');

  function apply(variant) {
    if (!variant) return;

    /* Price, and the sold-out marker beside it. */
    if (priceEl) {
      priceEl.innerHTML = variant.price_formatted +
        (variant.available ? '' : ' <span class="pd__soldout">Sold out</span>');
    }

    /* The plan that belongs to THIS variant. Monthly and annual are
       separate variants with separate plans, so this has to move with
       the choice or the buyer is billed on the wrong cycle. */
    if (planHidden) {
      planHidden.value = variant.plan_id || '';
      planHidden.disabled = !variant.plan_id;
    }
    if (recursEl) {
      if (variant.plan_name) {
        recursEl.hidden = false;
        recursEl.textContent = `${variant.plan_name} · you may cancel at any time.`;
      } else {
        recursEl.hidden = true;
      }
    }

    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.label : 'Sold out';
    }

    /* Keep the URL honest, so the address bar can be copied, shared or
       reloaded and land on the same edition. replaceState rather than
       pushState: choosing a band is refining one decision, not stepping
       somewhere new, and Back should leave the product entirely. */
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  root.addEventListener('change', (e) => {
    const input = e.target;
    if (input.name !== 'id') return;
    apply(byId.get(String(input.value)));
  });

  /* Landing on ?variant=… should agree with what is rendered. Liquid
     already selects the right radio, but the price and plan are worth
     syncing in case the page was served from cache. */
  const checked = root.querySelector('input[name="id"]:checked');
  if (checked) apply(byId.get(String(checked.value)));
})();
